import { Button, makeStyles } from '@material-ui/core';
import { ArchiveRounded as ArchiveIcon, UnarchiveRounded as UnarchiveIcon } from '@material-ui/icons';

import { DeliveryPointDetails } from '../../types/delivery-point-details.type';
import DeliveryPointTypeChip from '../Chips/DeliveryPointTypeChip.component';
import StatusChip from '../../../shared/components/Chips/StatusChip.component';

type Props = {
  deliveryPoint: DeliveryPointDetails;
  onArchiveActionClick: () => void;
};

const useStyles = makeStyles({
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',

    '& > h2': {
      margin: 0,
    },
  },

  archiveButton: {
    marginLeft: 'auto',
    textTransform: 'none',
  },
});

export function DeliveryPointDetailsHeader({ deliveryPoint, onArchiveActionClick }: Props) {
  const classes = useStyles();
  const isArchived = Boolean(deliveryPoint.archivedAt);

  return (
    <div className={classes.header}>
      <h2>{deliveryPoint.name}</h2>
      <DeliveryPointTypeChip type={deliveryPoint.type} />
      <StatusChip isActive={deliveryPoint.isActive} archived={isArchived} />
      <Button
        size="small"
        variant="outlined"
        className={classes.archiveButton}
        startIcon={isArchived ? <UnarchiveIcon /> : <ArchiveIcon />}
        onClick={onArchiveActionClick}
      >
        {isArchived ? 'Restaurer' : 'Archiver'}
      </Button>
    </div>
  );
}
